<template>
  <BaseList listSubtitulo="Lista de empresas" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded"
                    @click="abrirModal('informacoes', data.id, data.key)">
              <i class="fa fa-eye"></i> Visualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('editar', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, data.razao_social)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastraEmpresa
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarEmpresa'"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <InformacoesEmpresa
      v-if="modalAtivo === 'informacoes'"
      :idModal="'informacoesEmpresa'"
      @fechar="fecharModal"
      :itemKey="itemKeySelect"
  />

  <EditarEmpresa
      v-if="modalAtivo === 'editar'"
      :idModal="'editarEmpresa'"
      @fechar="fecharModal"
      @atualizarDados="atualizaDados"
      :itemKey="itemKeySelect"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastraEmpresa from "./CadastraEmpresa.vue";
import InformacoesEmpresa from "./InformacoesEmpresa.vue";
import EditarEmpresa from "./EditarEmpresa.vue";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaEmpresas",
  components: {
    BaseList,
    CadastraEmpresa,
    InformacoesEmpresa,
    EditarEmpresa,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      itemSelect: null,
      itemKeySelect: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'razao_social', header: 'NOME/RAZÃO SOCIAL',},
        {field: 'fantasia', header: 'FANTASIA',},
        {field: 'telefone', header: 'TELEFONE', align: 'text-center',},
        {field: 'cpf_cnpj', header: 'CPF/CNPJ', align: 'text-center',},
        {field: 'email_comercial', header: 'E-MAIL',},
        {field: 'status', header: 'STATUS', body: row => row.status || '', align: 'text-center',},
      ]
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, id = null, key = null) {
      this.modalAtivo = tipo;
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemKey, itemId, itemNome) {
      let url = apiUrl.empresas.retrieveUpdateDestroy(itemKey);
      alertDelete(itemKey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.empresas.createList, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
